<app-dialog
  class="custom-dialog"
  headerText="Login with a Custom OpenID Connect (OIDC) Provider"
  [showCancelButton]="true"
  cancelText="Cancel"
  [showTopCancelButton]="false"
  saveText="Log in"
  [saveButtonType]="'emphasized'"
  [body]="bodyTemplate"
  [validationFn]="isPathValid"
  (cancel)="onClose()"
  (save)="onSubmit()"
  [errorMsg]="errorText"
>
  <ng-template #bodyTemplate>
    @if (!isBusy()) {
      <div>
        <form (ngSubmit)="onSubmit()">
          <div class="text-wrapper">
            Enter the OIDC identifier or the path to the OIDC provider resource
            file used to register the custom OIDC provider with Unified Resource
            Manager. If you don’t know this identifier or path, please ask your
            administrator for the correct identifier or path.
          </div>
          <fd-form-input-message-group
            [triggers]="['mouseenter', 'mouseleave']"
          >
            <label fd-form-label for="customIdpPath"
              >OIDC Identifier or Path:
            </label>
            <!-- Invisible input to trigger autofocus due to fd-combobox limitation -->
            <input
              type="text"
              style="position: absolute; opacity: 0; height: 0"
              autofocus
            />
            <fd-combobox
              class="custom-combobox"
              [dropdownValues]="recentPaths"
              [(ngModel)]="customIdpPath"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="validatePath()"
              id="customIdpPath"
              placeholder="Enter an OIDC identifier or a path to an OIDC provider resource"
              [state]="showError ? 'error' : 'default'"
              fd-form-control
              autocomplete="off"
              [showDropdownButton]="false"
              [closeOnOutsideClick]="false"
            >
            </fd-combobox>
            @if (showError) {
              <fd-form-message type="error">
                Invalid format. Check your OIDC identifier or path. An OIDC
                identifier is case-sensitive and can include letters, digits,
                periods, underscores, and hyphens, for example: my-IdP-123. A
                path must start with "/" and can include letters, digits,
                periods, underscores, and hyphens, for example:
                /my-idp/custom-oidc.
              </fd-form-message>
            }
          </fd-form-input-message-group>
          <button type="submit" hidden></button>
        </form>
      </div>
    }
  </ng-template>
</app-dialog>
